export var setEventCategory = function setEventCategory(placement) {
  return placement === 'footer' ? 'Footer' : 'Navigation - mobile menu';
};